/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable complexity */
import EthereumNetwork from '@providers/EthereumNetwork'
import { THandleEstimateGasPrice } from '@providers/models/mint'
import PolygonNetwork from '@providers/PolygonNetwork'
import { generalUtils, networkUtils } from '@providers/utils'
import { IAbiItem, ICoupon } from '@types'

const SINGLE_TICKET_GAS_MARGIN = 200000
const __PLUS_TWENTY_PERCENT__ = 1.2
const __EIGHT_DIGITS__ = 8

export const handleEstimateGasPrice = async (
    provider: EthereumNetwork | PolygonNetwork,
    contractAbi: IAbiItem[],
    contractAddress: string,
    currentMintPrice: string,
    position: number,
    coupon: ICoupon,
    category: number,
    selectedOption: number,
    maxPerWallet: number,
): Promise<THandleEstimateGasPrice> => {
    const web3 = provider.getCurrentProvider()
    const accounts = await provider.getCurrentAccount()
    const selectedAddress = accounts[0]
    const Ticket = provider.getWeb3Contract(contractAbi, contractAddress)
    const gasPrice = await web3.eth.getGasPrice()
    try {
        const gasAmount = await Ticket.methods
            .safeMint(selectedAddress, selectedOption, position, category, coupon.r, coupon.s, coupon.v)
            .estimateGas({
                from: selectedAddress,
                gas: web3.utils.toWei(currentMintPrice, 'ether'),
            })

        const gasFee = (
            (gasAmount + SINGLE_TICKET_GAS_MARGIN) *
            (Number.parseFloat(web3.utils.fromWei(gasPrice, 'ether')) * __PLUS_TWENTY_PERCENT__)
        ).toFixed(__EIGHT_DIGITS__)

        return {
            success: true,
            gasFee,
        }
    } catch (error: any) {
        console.log('Error:', error)

        const errorMessage = generalUtils.mintErrorTreatment(error)

        if (errorMessage.code === 'MAX_WALLET_LIMIT') {
            const { mintAllowed } = await networkUtils.ethereum.handleMintAllowed(
                provider,
                contractAbi,
                contractAddress,
                position,
            )
            const message = `You have minted ${mintAllowed} out of the maximum ${maxPerWallet} NFTs`

            return {
                success: false,
                error: message,
            }
        }

        return {
            success: false,
            error: errorMessage.message,
        }
    }
}
